import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { app } from "./firebase.js";

export const db = getFirestore(app);

if (import.meta.env?.DEV) {
  const host = typeof window !== "undefined" ? window.location.hostname : "127.0.0.1";
  try {
    connectFirestoreEmulator(db, host, 8080);
  } catch (error) {
    console.warn("Firestore emulator connection warning:", error.message);
  }
}
